import { AppRoutes } from './routes';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import AppProvider from './providers/app';
import { Provider } from 'react-redux';
import { store } from './store';
import AuthListener from './components/Auth/AuthListener';
import { LoadScript } from '@react-google-maps/api';
import { useHubspotIdentify } from './hooks/useHubspotChat';
import { useAppSelector } from './hooks/hooks';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './lib/applicationInsights';
import ErrorFallback from './components/ErrorFallback';
// import Loader from './components/Elements/Loader';

// const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

// const options = {
//   clientSecret: 'pi_3QWrwOIWSqV83nYB1cfm2myF_secret_zL9mmZzZcKmBY2nxe84v97Va2',
//   theme: 'stripe',
// };

export function HubspotIdentifyWrapper() {
  const { userData } = useAppSelector((state: any) => state.auth);
  useHubspotIdentify(userData?.email); // always safe
  return null;
}

function App() {
  return (
    <LoadScript
      googleMapsApiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
      libraries={['places']}
    >
      <AuthListener />
      <AppInsightsErrorBoundary
        appInsights={reactPlugin}
        onError={ErrorFallback}
      >
        <AppRoutes />
      </AppInsightsErrorBoundary>
      <HubspotIdentifyWrapper />
      {/* <Loader /> */}
    </LoadScript>
  );
}

export default App;
